module.exports = __webpack_public_path__ + "static/media/videos-icon.6c1d60b9.svg";